import { render, staticRenderFns } from "./EditTermsPage.vue?vue&type=template&id=577691f7&scoped=true&"
import script from "./EditTermsPage.vue?vue&type=script&lang=js&"
export * from "./EditTermsPage.vue?vue&type=script&lang=js&"
import style0 from "./EditTermsPage.vue?vue&type=style&index=0&id=577691f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577691f7",
  null
  
)

export default component.exports